var initMenuMobile = function initMenuMobile() {
  var menuButton = document.querySelector('#nav-toggle-button');
  var menu = document.querySelector('#nav-menu');
  if (menuButton && menu) {
    menuButton.addEventListener('click', function () {
      menu.classList.toggle('open');
      menuButton.classList.toggle('open');
    });
  }
};
export { initMenuMobile };